import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../../theme';

/**
 * Custom hook that defines the styles for the tag component.
 */
const useTagStyles = makeStyles()(() => ({
  tagNode: {
    placeSelf: 'center',
    boxShadow: theme.containerShadow,
    padding: '5%',
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.borderRadius.m,
    cursor: 'pointer',
    backgroundColor: theme.background.paper,
  },
  tagName: {
    'color': theme.primary.light,
    'fontFamily': theme.fontFamily,
    'fontWeight': theme.fontWeight.medium,
    'marginBottom': theme.margin.s,
    '&:hover': {
      color: theme.primary.dark,
    },
  },
  tagQuestionCnt: {
    fontFamily: theme.fontFamily,
    color: colors.gray[300],
    marginTop: theme.margin.s,
    fontWeight: theme.fontWeight.medium,
  },
}));

export default useTagStyles;
